import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';

@Component
export default class GoListEndComponent extends Vue {
  @Prop(Boolean) readonly isSmartBriefing: boolean | true;
  @Prop(Boolean) readonly isAddingMoreData: boolean | true;
  @Prop(Boolean) readonly isLoadingResourceList: boolean | true;

  @Emit('goToTop')
  goToTop() {
    this.$store.commit('appStore/setGoToTopClicked', true);
  }
}
